"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const accounts_1 = require("companion-app-components/flux/accounts");
const selectors_1 = require("companion-app-components/flux/investmentHoldingList/selectors");
const investments_svg_1 = __importDefault(require("assets/zero-state-images/investments.svg"));
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const ValueField_1 = __importDefault(require("containers/OverviewPage/components/TopHoldings/ValueField"));
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const helpers_1 = require("containers/OverviewPage/components/helpers");
const style_1 = require("./style");
const useStyles = (0, mui_1.makeStyles)()(style_1.styles);
const InvestmentSummary = ({ hasInvestmentAccounts }) => {
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    const summaryData = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getSummarizedInvestmentData)(state, { accountIds: null, hasInvestmentAccounts }));
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { classes } = useStyles();
    const navigateToInvestmentsPage = () => {
        navigate('/investments?displayNode=INVESTMENT');
    };
    const dataIsNull = () => summaryData === null;
    const dataIsEmpty = () => !dataIsNull() && !hasInvestmentAccounts;
    const view = (0, helpers_1.computeViewState)(dataIsNull, dataIsEmpty, hasReportableAccounts);
    const { cashBalance, todaysChange, todaysChangePercent, totalValue } = summaryData !== null && summaryData !== void 0 ? summaryData : {};
    return (<div className={classes.root} onClick={navigateToInvestmentsPage} onKeyDown={navigateToInvestmentsPage} role="presentation" style={{ padding: '20px', cursor: (view === 'main' || view === 'empty') ? 'pointer' : 'auto' }}>
      {view === 'loading' &&
            <LoadingView_1.default />}
      {view === 'zero' &&
            <ZeroStateView_1.default icon={investments_svg_1.default} secondary="Sync your financial institutions to see your investment summary." size="small"/>}
      {view === 'empty' &&
            <ZeroStateView_1.default primary="No Accounts" icon={investments_svg_1.default} secondary="Use a Quicken desktop application to add an investment account, and then sync the account to Quicken web." size="small"/>}
      {view === 'main' &&
            <div className={classes.root}>
          <style_1.RowsWrap style={{ height: 98 }}>
            <style_1.RowWrap>
              <Typography_1.default color="inherit" variant="body2" className={classes.body2bold}>Securities</Typography_1.default>
              <AmountField_1.default variant="body2" className={classes.body2} value={totalValue} currencySymbol="USD" color="black"/>
            </style_1.RowWrap>
            <style_1.RowWrap>
              <Typography_1.default color="inherit" variant="body2" className={classes.body2bold}>Cash Balance</Typography_1.default>
              <AmountField_1.default variant="body2" className={classes.body2} value={cashBalance} currencySymbol="USD" color="black"/>
            </style_1.RowWrap>
            <style_1.RowWrap>
              <Typography_1.default color="inherit" variant="body2" className={classes.body2bold}>Total</Typography_1.default>
              <AmountField_1.default variant="body2" className={classes.body2} value={totalValue + cashBalance} currencySymbol="USD" color="black"/>
            </style_1.RowWrap>
          </style_1.RowsWrap>
          <Divider_1.default className={classes.divider}/>
          <style_1.RowWrap>
            <Typography_1.default color="inherit" variant="body2" className={classes.body2bold}>Today&rsquo;s Change</Typography_1.default>
            <div>
              <ValueField_1.default inputValue={todaysChangePercent} color="sign" type="percentage" valueChange={todaysChange} useParentheses fontSize={13}/>
            </div>
          </style_1.RowWrap>
        </div>}
    </div>);
};
exports.default = InvestmentSummary;
